import { ILoggedInUserInfo } from "./auth";
import { ICompany } from "./company";
import { IFarm } from "./intake/farm";
import { ICompanySettings } from "./intake/companySettings";
import { INotification } from "./notification";
import { IUser } from "./user";
import { ICropType } from "./cropType";

export interface StateType {
  openSideDrawer: boolean;
  loggedInUserInfo?: ILoggedInUserInfo;
  currentCompany?: ICompany;
  currentFarm?: IFarm;
  myProfile?: IUser;
  myCompanyProfile?: ICompany;
  myCompanySettings?: ICompanySettings;
  notifications?: INotification[];
  myClients?: ICompany[];
  cropTypes?: ICropType[];
  gasReportValueRanges?: { [key: string]: { min: number; max: number; heatmapAvailable?: boolean } };
  chamberReportValueRanges?: { [key: string]: { min: number; max: number } };
}

export const actionTypes = {
  setMyProfile: "setMyProfile",
  setMyCompanyProfile: "setMyCompanyProfile",
  setOpenSideDrawer: "setOpenSideDrawer",
  setLoggedInUserInfo: "setLoggedInUserInfo",
  setCurrentCompany: "setCurrentCompany",
  setCurrentFarm: "setCurrentFarm",
  setMyCompanySettings: "setMyCompanySettings",
  setNotifications: "setNotifications",
  setAllState: "setAllState",
  setMyClients: "setMyClients",
  setGasReportValueRanges: "setGasReportValueRanges",
  setChamberReportValueRanges: "setChamberReportValueRanges",
  setCropTypes: "setCropTypes",
};

export type ActionType =
  | { type: typeof actionTypes.setMyProfile; value: IUser | undefined }
  | {
      type: typeof actionTypes.setMyCompanyProfile;
      value: ICompany | undefined;
    }
  | { type: typeof actionTypes.setOpenSideDrawer; value: boolean }
  | {
      type: typeof actionTypes.setLoggedInUserInfo;
      value: ILoggedInUserInfo | undefined;
    }
  | {
      type: typeof actionTypes.setGasReportValueRanges;
      value: { [key: string]: { min: number; max: number; heatmapAvailable?: boolean } };
    }
  | {
      type: typeof actionTypes.setChamberReportValueRanges;
      value: { [key: string]: { min: number; max: number } };
    }
  | {
      type: typeof actionTypes.setCurrentCompany;
      value: ICompany | undefined;
    }
  | { type: typeof actionTypes.setCurrentFarm; value: IFarm | undefined }
  | {
      type: typeof actionTypes.setMyCompanySettings;
      value: ICompanySettings | undefined;
    }
  | {
      type: typeof actionTypes.setNotifications;
      value: INotification[] | undefined;
    }
  | { type: typeof actionTypes.setAllState; value: StateType }
  | { type: typeof actionTypes.setMyClients; value: ICompany[] }
  | { type: typeof actionTypes.setCropTypes; value: ICropType[] };

export interface ContextType {
  state: StateType;
  dispatch?: React.Dispatch<ActionType>;
  isHydrated?: boolean;
}
